import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import PageHero from '../Elements/PageHero';
import AboutResidentialCommercial from '../Elements/AboutResidentialCommercial';
import Capabilities from '../Elements/Capabilities';
import CtaBand from '../Elements/CtaBand';
import Contact from '../Elements/Contact';
import useReveal from '../../hooks/useReveal';
import usePageMeta from '../../hooks/usePageMeta';
import { residentialCommercial as data } from '../../content/site';

const ServicesResidentialCommercial = () => {
  useReveal();
  usePageMeta({
    title: `${data.title} | LIDA Engineering`,
    description: data.lead,
  });

  return (
    <>
      <Header overHero />
      <main id="main" className="page-content">
        <PageHero
          eyebrow={data.eyebrow}
          title={data.title}
          lead={data.lead}
          image={data.heroImage}
          imageAlt="A LIDA Engineering commercial building nearing completion"
        />
        <AboutResidentialCommercial />
        <Capabilities
          eyebrow="All Services"
          heading="Everything we can take on for you."
        />
        <CtaBand />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default ServicesResidentialCommercial;
